import React, { useEffect, useState } from "react";
import { client } from "@/lib/api";
import { toast } from "sonner";

// WW-213 · the hourly expiry job ships off; while off a run writes nothing.
const box = { padding: 16, borderRadius: 14, border: "1px solid var(--ww-line)", background: "var(--ww-surface)" };
const btn = { padding: "10px 16px", borderRadius: 10, border: "1px solid var(--ww-line-strong)", background: "transparent",
  color: "var(--ww-text)", fontFamily: "Poppins", fontWeight: 700, fontSize: 13, minHeight: 40, cursor: "pointer" };

export const QueueExpiryPanel = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => client.get("/admin/ops/queue-expiry/status").then((r) => setS(r.data)).catch(() => toast.error("couldn't load"));
  useEffect(() => { load(); }, []);
  const act = async (fn) => { setBusy(true); try { await fn(); await load(); } catch { toast.error("failed"); } finally { setBusy(false); } };
  const last = s?.last_run;
  return (
    <div data-testid="ops-card-queue-expiry" style={box}>
      <h2 style={{ fontFamily: "Poppins", fontWeight: 800, fontSize: 18 }}>WW-213 · past events leave the queue</h2>
      <p style={{ fontFamily: "Arial", fontSize: 13, color: "var(--ww-text-muted)", marginTop: 4 }}>
        every hour (on the drive watcher's 15 minute timer, no scheduled job slot), pending events whose last moment has passed move to expired (an admin can restore them). events that are already over when they arrive are not queued.
      </p>
      {s && (
        <div className="mt-3" style={{ fontFamily: "Arial", fontSize: 13 }}>
          <p data-testid="queue-expiry-state">hourly expiry is <b>{s.enabled ? "on" : "off"}</b></p>
          <p data-testid="queue-expiry-last-run" style={{ color: "var(--ww-text-muted)" }}>
            last run: {last ? `${last.started_at.slice(0, 16).replace("T", " ")} UTC · ${last.trigger} · ${last.enabled ? `found ${last.found} · ${last.expired} expired` : "off, nothing written"}` : "never"}
          </p>
          <div className="mt-2 flex flex-wrap gap-2">
            <button data-testid="queue-expiry-toggle" disabled={busy} style={btn}
                    onClick={() => act(() => client.post("/admin/ops/queue-expiry/switch", { on: !s.enabled }))}>
              {s.enabled ? "turn off" : "turn on"}
            </button>
            <button data-testid="queue-expiry-run-now" disabled={busy} style={btn}
                    onClick={() => act(() => client.post("/admin/ops/queue-expiry/run-now"))}>run now</button>
          </div>
          <p className="mt-3" style={{ color: "var(--ww-text-muted)" }}>not queued because already over, last 7 days</p>
          {s.ingest_skips.length ? (
            <table data-testid="queue-expiry-skips" className="mt-1 w-full">
              <tbody>
                {s.ingest_skips.map((k) => (
                  <tr key={`${k.day}-${k.source}`} data-testid={`queue-expiry-skip-${k.day}-${k.source}`}>
                    <td>{k.day}</td><td>{k.source}</td><td style={{ textAlign: "right" }}>{k.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <p data-testid="queue-expiry-skips-empty" style={{ color: "var(--ww-text-muted)" }}>none yet</p>}
        </div>
      )}
    </div>
  );
};
